const EMPLOYEE_LIST_EVENTS = {
  LIST_START: 'LIST_START',
  LIST_SUCCESS: 'LIST_SUCCESS',
  LIST_FAILURE: 'LIST_FAILURE',
}

export default EMPLOYEE_LIST_EVENTS
